/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-01T15:04:14+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-01T15:04:44+02:00
*/


export const DIALOG = 'dialog';
export const INLINE = 'inline';

export default {
  dialog: DIALOG,
  inline: INLINE,
};
